import { createContext } from "react";

export const ValidationErrorsContext = createContext<{
    errors: Record<string, string>;
    clearError: (key: string) => void;
}>({ errors: {}, clearError: () => {} });
